import api from './api';

export class cardProcessorService {
  static getClientId(clientId, forceRefresh = false) {
    return api
      .get('clientId', { client_id: clientId, force_refresh: forceRefresh })
      .then((response) => response.data);
  }

  static getParameters() {
    return api.get('parameters').then((response) => response.data);
  }
}
